import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, CircleMarker, Polyline, Tooltip } from "react-leaflet";

const pt = (c) => (c && c.lat != null && c.lng != null ? [c.lat, c.lng] : null);

export function TrackingMap({ shipment }) {
  const origin = pt(shipment.origin_coords);
  const dest = pt(shipment.destination_coords);
  const current = pt(shipment.current_location);
  const path = (shipment.events || []).map(pt).filter(Boolean);
  const all = [origin, ...path, current, dest].filter(Boolean);
  if (!all.length) {
    return <div className="h-80 flex items-center justify-center bg-slate-100 text-slate-500 text-sm" data-testid="map-unavailable">Map location not available yet</div>;
  }
  const bounds = all.length > 1 ? all : undefined;
  return (
    <div data-testid="tracking-map">
    <MapContainer bounds={bounds} center={bounds ? undefined : all[0]} zoom={bounds ? undefined : 6}
      boundsOptions={{ padding: [40, 40] }} scrollWheelZoom={false} className="h-80 md:h-[420px] w-full">
      <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {origin && dest && <Polyline positions={[origin, dest]} pathOptions={{ color: "#94A3B8", dashArray: "6 8", weight: 2 }} />}
      {path.length > 1 && <Polyline positions={path} pathOptions={{ color: "#FF6B00", weight: 3 }} />}
      {origin && <CircleMarker center={origin} radius={7} pathOptions={{ color: "#0A192F", fillColor: "#fff", fillOpacity: 1, weight: 3 }}><Tooltip>Origin: {shipment.origin}</Tooltip></CircleMarker>}
      {dest && <CircleMarker center={dest} radius={7} pathOptions={{ color: "#10B981", fillColor: "#fff", fillOpacity: 1, weight: 3 }}><Tooltip>Destination: {shipment.destination}</Tooltip></CircleMarker>}
      {current && <CircleMarker center={current} radius={10} pathOptions={{ color: "#fff", fillColor: "#FF6B00", fillOpacity: 1, weight: 3 }}><Tooltip permanent direction="top">Now: {shipment.current_location.name}</Tooltip></CircleMarker>}
    </MapContainer>
    </div>
  );
}
